import React, { FC, memo } from 'react'
import RowBuilder from 'uiComponents/molecules/TileGrid/RowBuilder'
import TileGrid, {
  RowComponentMap,
} from 'uiComponents/molecules/TileGrid/TileGrid'
import { useResponsiveRowBuilder } from './helpers'

interface StreamProps {
  loading?: boolean
  rowBuilder: RowBuilder
  rowComponentMap: RowComponentMap
}

export interface ScrollPositionIndexes {
  overscanStartIndex: number
  overscanStopIndex: number
}

const Stream: FC<StreamProps> = memo(
  ({ loading, rowBuilder, rowComponentMap }) => {
    useResponsiveRowBuilder(rowBuilder)

    return (
      <TileGrid
        loading={loading}
        rowBuilder={rowBuilder}
        rowComponentMap={rowComponentMap}
        rowIndexOffset={0}
      />
    )
  },
)

export default Stream
